import React from 'react'
import NavBar from '../components/Home/NavBar'
import Anexo from '../components/Forms/ConsentimientoBilateral/Anexo'

const Consentimiento = () => {
  return (
    <div>
        <NavBar />
        <Anexo />
    </div>
  )
}

export default Consentimiento